import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-billing-detail.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-billing-detail.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class ServiceBillingDetailEffects {

  createServiceBillingDetail$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceBillingDetails),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_BILLING_DETAILS,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceBillingDetail({ serviceBillingDetail: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateServiceBillingDetail$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editServiceBillingDetails),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_SERVICE_BILLING_DETAILS,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceBillingDetail({ serviceBillingDetail: result?.data }));
              await this.notificationService.successMessage('Updated Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServiceBillingDetail$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceBillingDetails),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_BILLING_DETAILS,
        variables: {
          billingUniqueId: action?.billingUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceBillingDetail({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceBillingDetails$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceBillingDetails),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_BILLING_DETAILS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service billing details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceBillingDetails({ serviceBillingDetails: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  citizenGetInstitutionServiceBillings$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetInstitutionServiceBillings),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_INSTITUTION_SERVICE_BILLINGS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching citizen service billing details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceBillingDetails({ serviceBillingDetails: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
